(function () {
  'use strict';

  angular.module('dashboard.stock', ['ngResource']);
})();
